import { Hero } from "../components/landing/Hero";
import { WhyNow } from "../components/landing/WhyNow";
import { Services } from "../components/landing/Services";
import { Process } from "../components/landing/Process";
import { Pricing } from "../components/landing/Pricing";
import { Faq } from "../components/landing/Faq";
import { CTA } from "../components/landing/CTA";
import { Sources } from "../components/landing/Sources";
import { Footer } from "../components/landing/Footer";

export function Landing() {
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <Hero />
      <WhyNow />
      <Services />
      <Process />
      <Pricing />
      <Faq />
      <CTA />
      <Sources />
      <Footer />
    </div>
  );
}
